import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spec-history',
  templateUrl: './spec-history.component.html',
  styles: [
  ]
})
export class SpecHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
